import _ from 'lodash'
import { room } from '@/constants/room.js'
// 部屋編集情報
const Room = {
  namespaced: true,
  state: {
    // 部屋項目
    room: _.cloneDeep(room),
    // 編集前初期データ
    initData: [],
    // 新規作成時に必要な部屋データ
    newRoomData: {},
    // 物件登録/編集に必要な項目
    item: {
      prefList: [],
      shikuList: [],
      chosonList: [],
      azaList: [],
      address: '',
      loadMapAddress: false,
      loadMapLatLon: false,
      lineList: [],
      stationList1: [],
      stationList2: [],
      stationList3: [],
      stationList4: [],
    },
  },
  getters: {
    getRoomId: state => {
      return state.room.rent_bc_regulars.room_id
    },
    getRoom: state => {
      return state.room
    },
    getInitData: state => {
      return state.initData
    },
    getNewRoomData: state => {
      return state.newRoomData
    },
    getItem: state => {
      return state.item
    },
  },
  mutations: {
    setRoom(state, room) {
      if (_.isArray(room.rent_bc_catchcopies.share)) room.rent_bc_catchcopies.share = {}
      if (_.isArray(room.rent_bc_catchcopies.shop)) room.rent_bc_catchcopies.shop = {}
      if (_.isArray(room.rent_bc_3nosuke_webs.share)) room.rent_bc_3nosuke_webs.share = {}
      if (_.isArray(room.rent_bc_3nosuke_webs.shop)) room.rent_bc_3nosuke_webs.shop = {}
      state.room = room
    },
    setRentBcEquipments(state, equipments) {
      state.room.rent_bc_equipments = equipments
    },
    setInitData(state, data) {
      state.initData = data
    },
    setNewRoomData(state, data) {
      state.newRoomData = data
    },
    setItem(state, item) {
      state.item = item
    },
    setWarranty(state, item) {
      state.room.rent_bc_regulars.waranty_company = item.id
      // 保証料（初回契約時）
      state.room.rent_bc_regulars.waranty_fee1 = item.waranty_fee1
      state.room.rent_bc_regulars.sel_waranty_fee1_unit = item.sel_waranty_fee1_unit
      state.room.rent_bc_regulars.tax_waranty_fee1 = item.tax_waranty_fee1
      // 保証料（更新時）
      state.room.rent_bc_regulars.waranty_fee2 = item.waranty_fee2
      state.room.rent_bc_regulars.sel_waranty_fee2_unit = item.sel_waranty_fee2_unit
      state.room.rent_bc_regulars.tax_waranty_fee2 = item.tax_waranty_fee2
      // 保証料（月額）
      state.room.rent_bc_regulars.waranty_fee3 = item.waranty_fee3
      state.room.rent_bc_regulars.sel_waranty_fee3_unit = item.sel_waranty_fee3_unit
      state.room.rent_bc_regulars.tax_waranty_fee3 = item.tax_waranty_fee3
      // 備考
      state.room.rent_bc_regulars.waranty_fee = item.fee_surety
    },
  },
  actions: {
    reset({ commit }) {
      return new Promise(resolve => {
        commit('setRoom', _.cloneDeep(room))
        resolve()
      })
    },
    resetRentBcEquipments({ commit }) {
      const _room = _.cloneDeep(room)
      commit('setRentBcEquipments', _room.rent_bc_equipments)
    },
  },
}

export default Room
